
(function() {
  'use strict';

  function getCrossGalleryInfo() {
    var openDlg = document.querySelector('.page-gallery-dialog[open]');
    if (!openDlg) return null;

    var galId = openDlg.id.replace(/-dialog$/, '');
    var curGal = document.getElementById(galId);
    if (!curGal) return null;

    var cur   = parseInt(curGal.dataset.curIdx || '0', 10);
    var total = parseInt(curGal.dataset.total  || '0', 10);
    var allGals = Array.from(document.querySelectorAll('.page-gallery'));
    var gi = allGals.indexOf(curGal);
    if (gi === -1) return null;

    return { curGal: curGal, cur: cur, total: total, allGals: allGals, gi: gi };
  }

  function tryNextGallery(info) {
    if (info.cur >= info.total - 1) {
      info.curGal.__close();
      if (info.gi < info.allGals.length - 1) {
        info.allGals[info.gi + 1].__open(0);
      } else {
        info.allGals[0].__open(0);
      }
      return true;
    }
    return false;
  }

  function tryPrevGallery(info) {
    if (info.cur <= 0) {
      info.curGal.__close();
      if (info.gi > 0) {
        var prev = info.allGals[info.gi - 1];
        prev.__open(parseInt(prev.dataset.total || '0', 10) - 1);
      } else {
        var last = info.allGals[info.allGals.length - 1];
        last.__open(parseInt(last.dataset.total || '0', 10) - 1);
      }
      return true;
    }
    return false;
  }

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var info = getCrossGalleryInfo();
    if (!info) return;

    if (e.key === 'ArrowRight' && tryNextGallery(info)) {
      e.stopImmediatePropagation();
    } else if (e.key === 'ArrowLeft' && tryPrevGallery(info)) {
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', function(e) {
    var nextBtn = e.target.closest('.page-gallery-dialog__next');
    var prevBtn = e.target.closest('.page-gallery-dialog__prev');
    if (!nextBtn && !prevBtn) return;

    var info = getCrossGalleryInfo();
    if (!info) return;

    if (nextBtn && tryNextGallery(info)) {
      e.stopImmediatePropagation();
    } else if (prevBtn && tryPrevGallery(info)) {
      e.stopImmediatePropagation();
    }
  }, true);
})();

(function () {
  'use strict';

  function initGalleryPreload() {
    var imgs = document.querySelectorAll('.page-gallery-dialog__img');
    imgs.forEach(function (img) {
      new MutationObserver(function () {
        img.style.opacity = '0';
      }).observe(img, { attributes: true, attributeFilter: ['src'] });

      img.addEventListener('load', function () {
        img.style.opacity = '1';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryPreload);
  } else {
    initGalleryPreload();
  }
})();

(function () {
  'use strict';

  function getAllVariants(selects) {
    if (!selects) return null;
    var script = selects.querySelector('script[data-all-variants]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function getSelectedOptions(selects) {
    var result = {};
    var radios = selects.querySelectorAll('fieldset input[type="radio"]:checked');
    radios.forEach(function (r) {
      var idx = r.getAttribute('data-index');
      if (idx) result[idx] = r.value;
    });
    return result;
  }

  function findVariant(variants, option1, option2, option3) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === option1 && v.option2 === option2 && v.option3 === option3) {
        return v;
      }
    }
    return null;
  }

  function findFirstAvailable(variants, option1) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === option1 && v.available) return v;
    }
    return null;
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-single-option-selector]')) return;

    var selects = input.closest('variant-selects');
    if (!selects) return;

    var variants = getAllVariants(selects);
    if (!variants) return;

    var opts = getSelectedOptions(selects);
    var match = findVariant(variants, opts.option1, opts.option2, opts.option3);

    if (match) return;

    var fallback = findFirstAvailable(variants, opts.option1);
    if (!fallback) return;

    if (fallback.option2 !== opts.option2) {
      var opt2Radios = selects.querySelectorAll('input[data-index="option2"]');
      for (var i = 0; i < opt2Radios.length; i++) {
        if (opt2Radios[i].value === fallback.option2) {
          opt2Radios[i].checked = true;
          break;
        }
      }
    }

    if (fallback.option3 !== opts.option3) {
      var opt3Radios = selects.querySelectorAll('input[data-index="option3"]');
      for (var j = 0; j < opt3Radios.length; j++) {
        if (opt3Radios[j].value === fallback.option3) {
          opt3Radios[j].checked = true;
          break;
        }
      }
    }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-single-option-selector]')) return;

    var selects = input.closest('variant-selects');
    if (!selects) return;

    var variants = getAllVariants(selects);
    if (!variants) return;

    var opts = getSelectedOptions(selects);
    var variant = findVariant(variants, opts.option1, opts.option2, opts.option3);
    if (!variant) return;

    var productInfo = selects.closest('product-info');
    if (!productInfo) return;

    var formatMoney = window.theme && window.theme.formatMoney;
    if (formatMoney) {
      var priceEls = productInfo.querySelectorAll('[data-product-price]');
      var compareEls = productInfo.querySelectorAll('[data-compare-price]');
      var priceFormat = (window.theme.settings && window.theme.settings.currency_code_enable)
        ? window.theme.moneyWithCurrencyFormat
        : window.theme.moneyFormat;

      var priceHTML = variant.price === 0
        ? (window.theme.strings && window.theme.strings.free || 'Free')
        : formatMoney(variant.price, priceFormat);

      priceEls.forEach(function (el) {
        el.innerHTML = priceHTML;
      });

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEls.forEach(function (el) {
        if (hasCompare) {
          el.innerHTML = formatMoney(variant.compare_at_price, priceFormat);
          el.classList.remove('hidden');
          var sibling = el.closest('[data-price-wrapper]');
          if (sibling) {
            var priceEl = sibling.querySelector('[data-product-price]');
            if (priceEl) priceEl.classList.add('product__price--sale');
          }
        } else {
          el.classList.add('hidden');
          var sibling2 = el.closest('[data-price-wrapper]');
          if (sibling2) {
            var priceEl2 = sibling2.querySelector('[data-product-price]');
            if (priceEl2) priceEl2.classList.remove('product__price--sale');
          }
        }
      });

      var formWrapper = productInfo.querySelector('[data-form-wrapper]');
      if (formWrapper) {
        formWrapper.dataset.variantPrice = variant.price.toString();
        formWrapper.dataset.variantTitle = variant.title || '';
        if (hasCompare) {
          formWrapper.dataset.variantComparePrice = variant.compare_at_price.toString();
        } else {
          delete formWrapper.dataset.variantComparePrice;
        }
      }

      if (window.__bpGroupDiscount && typeof window.__bpGroupDiscount.refreshProductPage === 'function') {
        window.__bpGroupDiscount.refreshProductPage();
      }
    }

    if (variant.featured_media) {
      var mediaId = variant.featured_media.id;
      var slider = productInfo.querySelector('[data-product-single-media-slider]');
      if (slider && window.theme && window.theme.Flickity) {
        var flkty = window.theme.Flickity.data(slider);
        if (flkty && flkty.isActive) {
          var cell = slider.querySelector('[data-id="' + mediaId + '"]');
          if (cell) {
            var idx = Array.from(cell.parentNode.children).indexOf(cell);
            if (idx >= 0) flkty.select(idx);
          }
        }
      }
    }

    var hiddenInputs = productInfo.querySelectorAll('input[name="id"][data-product-select]');
    hiddenInputs.forEach(function (inp) {
      inp.value = variant.id;
    });

  }, false);

})();

(function () {
  'use strict';

  var ICON_FILES = [
    'award-winning-photographer-icon.svg',
    'camera-icon.svg',
    'enterprise-and-teams-icon.svg',
    'events-and-video-icon.svg',
    'general-inquiries-icon.svg',
    'group-rates-icon.svg',
    'how-to-prepare-guide-icon.svg',
    'live-preview-icon.svg',
    'on-site-icon.svg',
    'online-proof-gallery-icon.svg',
    'outdoor-option-icon.svg',
    'over-100-backdrop-options-icon.svg',
    'posing-guidance-icon.svg',
    'professional-lighting-setup-icon.svg',
    'quick-turnaround-of-final-images-icon.svg',
    'retouched-high-res-images-icon.svg',
    'rush-service-options-icon.svg',
    'service-add-ons-icon.svg',
    'top-notch-service-icon.svg',
    'tote-simple-thin.svg',
    'wardrobe-styling-consultation-icon.svg',
    'your-choice-of-location-icon.svg'
  ];

  var FALLBACK_MAP = {};
  ICON_FILES.forEach(function (f) {
    var key = f.replace(/\.svg$/, '');
    FALLBACK_MAP[key] = f;
  });

  var assetBase = null;

  function getAssetBase() {
    if (assetBase) return assetBase;
    var el = document.querySelector(
      'link[href*="/assets/theme.css"], link[href*="/assets/custom.css"], script[src*="/assets/theme.js"], script[src*="/assets/custom.js"]'
    );
    if (el) {
      var href = el.href || el.src;
      assetBase = href.replace(/\/assets\/[^?]+.*$/, '/assets/');
    }
    return assetBase;
  }

  function getAssetUrl(filename) {
    var base = getAssetBase();
    return base ? base + filename : null;
  }

  function fixBrokenIcons() {
    var images = document.querySelectorAll('img');
    images.forEach(function (img) {
      var src = img.src || img.currentSrc || '';
      if (!src) return;

      var matchedAsset = null;
      var keys = Object.keys(FALLBACK_MAP);
      for (var i = 0; i < keys.length; i++) {
        if (src.indexOf(keys[i]) !== -1) {
          matchedAsset = FALLBACK_MAP[keys[i]];
          break;
        }
      }
      if (!matchedAsset) return;

      img.addEventListener('error', function onErr() {
        img.removeEventListener('error', onErr);
        var fallbackUrl = getAssetUrl(matchedAsset);
        if (fallbackUrl && img.src !== fallbackUrl) {
          img.src = fallbackUrl;
        }
      });

      if (img.complete && img.naturalWidth === 0) {
        var fallbackUrl = getAssetUrl(matchedAsset);
        if (fallbackUrl) img.src = fallbackUrl;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBrokenIcons);
  } else {
    fixBrokenIcons();
  }
  document.addEventListener('shopify:section:load', fixBrokenIcons);
})();

(function () {
  'use strict';

  var userCleared = false;

  document.addEventListener('keydown', function (e) {
    if (!e.target.matches || !e.target.matches('[data-quantity-field]')) return;
    if (e.key === 'Backspace' || e.key === 'Delete') {
      userCleared = true;
    } else {
      userCleared = false;
    }
  }, true);

  document.addEventListener('input', function (e) {
    var field = e.target;
    if (!field.matches || !field.matches('[data-quantity-field]')) return;

    var val = field.value.replace(/\D/g, '');
    if (val === '' && userCleared) {
      e.stopImmediatePropagation();
      return;
    }
  }, true);

  function enforceMin(field) {
    var val = parseInt(field.value, 10);
    var min = parseInt(field.getAttribute('min'), 10) || 1;
    if (!val || val < min) {
      field.value = min;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  document.addEventListener('blur', function (e) {
    if (e.target.matches && e.target.matches('[data-quantity-field]')) {
      userCleared = false;
      enforceMin(e.target);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-quantity-field]')) {
      userCleared = false;
      enforceMin(e.target);
    }
  });
})();

(function () {
  'use strict';

  var DISCOUNT_CONFIG = {
    enabled: true,
    additionalImageCost: 54.98,
    tiers: [
      { minQty: 2,  percentage: 20 },
      { minQty: 5,  percentage: 25 },
      { minQty: 10, percentage: 30 },
      { minQty: 20, percentage: 35 },
      { minQty: 30, percentage: 40 },
      { minQty: 40, percentage: 45 },
      { minQty: 50, percentage: 50 },
      { minQty: 60, percentage: 55 },
      { minQty: 70, percentage: 60 },
      { minQty: 80, percentage: 65 }
    ]
  };

  var IMAGE_WORDS = {
    one: 1, two: 2, three: 3, four: 4, five: 5,
    six: 6, seven: 7, eight: 8, nine: 9, ten: 10
  };
  function parseExtraImages(variantTitle) {
    if (!variantTitle) return 0;
    var segments = variantTitle.split('/');
    if (segments.length < 3) return 0;
    var imgSeg = segments[2].trim().toLowerCase();
    var imageCount = IMAGE_WORDS[imgSeg] || parseInt(imgSeg, 10);
    if (isFinite(imageCount) && imageCount >= 1) return imageCount - 1;
    return 0;
  }

  function findTierPct(qty) {
    var bestPct = 0;
    var bestMinQty = 0;
    var tiers = DISCOUNT_CONFIG.tiers || [];
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (qty >= t.minQty && t.minQty >= bestMinQty) {
        bestMinQty = t.minQty;
        bestPct = t.percentage;
      }
    }
    return bestPct;
  }

  function moneyFmt(amount) {
    var parts = amount.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function pad2(n) { n = Number(n) || 0; return (n < 10 ? '0' : '') + n; }
  function peopleWord(n) { return Number(n) === 1 ? 'person' : 'people'; }
  function nextBracket(qty) {
    var tiers = DISCOUNT_CONFIG.tiers || [];
    var best = null;
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (t.minQty > qty && (!best || t.minQty < best.minQty)) best = t;
    }
    return best;
  }
  function nudgeText(qty) {
    var nb = nextBracket(qty);
    if (!nb) return 'Top group discount applied';
    var more = nb.minQty - qty;
    return 'Add ' + more + ' more ' + peopleWord(more) + ' for −' + nb.percentage + '%';
  }
  function pkgBackdrop(variantTitle) {
    var bd = ((variantTitle || '').split('/')[1] || '').trim();
    if (/^Colour\s*\(/i.test(bd)) return 'Colour';
    var m = bd.match(/^No Backdrop \((.+)\)$/i);
    if (m) return m[1];
    return bd || 'Portrait';
  }
  function pkgTitle(variantTitle) {
    var bd = pkgBackdrop(variantTitle);
    if (/^Blurred$/i.test(bd)) return 'Portrait with Blurred Background';
    if (/^In ?Focus$/i.test(bd)) return 'Portrait with In-Focus Background';
    return 'Portrait with ' + bd + ' Backdrop';
  }

  window.BP_DISCOUNT = {
    config: DISCOUNT_CONFIG,
    tiers: DISCOUNT_CONFIG.tiers,
    additionalImageCost: DISCOUNT_CONFIG.additionalImageCost,
    floorPrice: 226.98,
    findTierPct: findTierPct,
    parseExtraImages: parseExtraImages,
    moneyFmt: moneyFmt
  };

  function setText(el, txt) {
    if (el && el.textContent !== txt) el.textContent = txt;
  }
  function setHidden(el, hide) {
    if (!el) return;
    if (hide && !el.hidden) el.hidden = true;
    if (!hide && el.hidden) el.hidden = false;
  }

  function computeLineDiscount(card) {
    if (!DISCOUNT_CONFIG.enabled) return null;

    var priceCents = parseInt(card.dataset.variantPriceCents, 10);
    if (!priceCents || isNaN(priceCents)) return null;
    var variantPrice = priceCents / 100;

    var qtyField = card.querySelector('[data-quantity-field]');
    var qty = qtyField ? parseInt(qtyField.value, 10) : 1;
    if (isNaN(qty) || qty < 2) return null;

    var extraImages = parseExtraImages(card.dataset.variantTitle || '');
    var basePrice = variantPrice - extraImages * DISCOUNT_CONFIG.additionalImageCost;
    if (basePrice <= 0) return null;

    var tierPct = findTierPct(qty);
    if (tierPct <= 0) return null;

    var discountPerUnit = Math.round(basePrice * (tierPct / 100) * 100) / 100;
    if (discountPerUnit <= 0) return null;

    var originalTotal  = Math.round(variantPrice * qty * 100) / 100;
    var totalDiscount  = Math.round(discountPerUnit * qty * 100) / 100;
    var finalTotal     = Math.round((originalTotal - totalDiscount) * 100) / 100;
    var finalPerPerson = Math.round((variantPrice - discountPerUnit) * 100) / 100;

    return {
      variantPrice: variantPrice,
      qty: qty,
      originalTotal: originalTotal,
      totalDiscount: totalDiscount,
      finalTotal: finalTotal,
      perOriginal: variantPrice,
      perFinal: finalPerPerson
    };
  }

  function renderCard(card, result) {
    var perOld = card.querySelector('[data-v2-pp-old]');
    var perNew = card.querySelector('[data-v2-pp-new]');
    var lineTot = card.querySelector('[data-v2-line-total]');

    if (result) {
      setText(perOld, moneyFmt(result.perOriginal));
      setText(perNew, moneyFmt(result.perFinal));
      setText(lineTot, result.qty >= 2 ? moneyFmt(result.finalTotal) : '');
    } else {
      var cents = parseInt(card.dataset.variantPriceCents, 10);
      setText(perOld, '');
      setText(perNew, moneyFmt(cents ? cents / 100 : 0));
      var qf = card.querySelector('[data-quantity-field]');
      var q = qf ? parseInt(qf.value, 10) : 1;
      setText(lineTot, (q >= 2 && cents) ? moneyFmt((cents / 100) * q) : '');
    }
  }

  function applyGroupDiscount() {
    var cards = document.querySelectorAll('.cart-item-v2');
    var totalSavings = 0;
    var totalQty = 0;
    var totalFinal = 0;
    var subtotalSum = 0;

    var discountedIdx = [];
    var discPeople = 0;
    var combinedDisc = 0;
    var top = null;

    cards.forEach(function (card) {
      var qtyField = card.querySelector('[data-quantity-field]');
      var qty = qtyField ? parseInt(qtyField.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      totalQty += qty;

      var priceCents = parseInt(card.dataset.variantPriceCents, 10);
      var variantPrice = priceCents ? priceCents / 100 : 0;
      var idx = parseInt(card.dataset.itemIndex, 10) || (discountedIdx.length + 1);
      subtotalSum += variantPrice * qty;

      var result = computeLineDiscount(card);
      renderCard(card, result);

      if (result) {
        totalSavings += result.totalDiscount;
        totalFinal   += result.finalTotal;
        discountedIdx.push(idx);
        discPeople   += qty;
        combinedDisc += result.totalDiscount;
      } else {
        totalFinal   += variantPrice * qty;
      }

      var lineTotal = variantPrice * qty;
      if (!top || lineTotal > top.total) {
        top = { idx: idx, qty: qty, price: variantPrice, total: lineTotal,
                title: pkgTitle(card.dataset.variantTitle) };
      }
    });

    totalSavings = Math.round(totalSavings * 100) / 100;
    totalFinal   = Math.round(totalFinal * 100) / 100;
    combinedDisc = Math.round(combinedDisc * 100) / 100;

    var meter = document.querySelector('[data-v2-meter]');
    if (meter) {
      var ticksWrap = meter.querySelector('[data-v2-meter-ticks]');
      if (ticksWrap && !ticksWrap.children.length) {
        var labelSet = { 20: 1, 30: 1, 40: 1, 50: 1, 65: 1 };
        (DISCOUNT_CONFIG.tiers || []).forEach(function (t) {
          var tick = document.createElement('span');
          tick.className = 'cart__meter__tick' + (labelSet[t.percentage] ? ' is-major' : '');
          tick.style.left = Math.min(100, (t.percentage / 65) * 100) + '%';
          if (labelSet[t.percentage]) tick.setAttribute('data-label', t.percentage + '%');
          ticksWrap.appendChild(tick);
        });
      }
      if (top) {
        var topPct = top.qty >= 2 ? findTierPct(top.qty) : 0;
        setText(meter.querySelector('[data-v2-meter-label]'),
                pad2(top.idx) + ' · ' + top.title + ' · ' + top.qty + ' ' + peopleWord(top.qty));
        var fill = meter.querySelector('[data-v2-meter-fill]');
        if (fill) fill.style.width = Math.min(100, (topPct / 65) * 100) + '%';
        var pctEl = meter.querySelector('[data-v2-meter-pct]');
        if (pctEl) setText(pctEl, topPct > 0 ? '−' + topPct + '%' : '');
        setText(meter.querySelector('[data-v2-meter-nudge]'), nudgeText(top.qty));
        setHidden(meter, false);
      } else {
        setHidden(meter, true);
      }
    }

    var combinedEl = document.querySelector('[data-v2-combined-disc]');
    if (combinedEl) {
      var cLabel = combinedEl.querySelector('[data-v2-combined-label]');
      var cAmt   = combinedEl.querySelector('[data-v2-combined-amt]');
      if (discountedIdx.length) {
        var padded = discountedIdx.map(pad2);
        var nums = padded.length === 1 ? padded[0]
                 : padded.length === 2 ? padded[0] + ' & ' + padded[1]
                 : padded.join(' · ');
        setText(cLabel, nums + ' · Group discount · ' +
                discPeople + ' ' + peopleWord(discPeople));
        setText(cAmt, '−' + moneyFmt(combinedDisc));
        setHidden(cAmt, false);
      } else {
        setText(cLabel, 'Group discount · applies at two or more people per session');
        setText(cAmt, '');
        setHidden(cAmt, true);
      }
      setHidden(combinedEl, cards.length === 0);
    }

    var headerCount = document.querySelector('[data-v2-header-count]');
    if (headerCount) setText(headerCount, cards.length ? '· ' + cards.length : '');

    subtotalSum = Math.round(subtotalSum * 100) / 100;
    var subtotalEl = document.querySelector('[data-v2-subtotal]');
    if (subtotalEl) setText(subtotalEl, moneyFmt(subtotalSum));
    var subtotalPeopleEl = document.querySelector('[data-v2-subtotal-people]');
    if (subtotalPeopleEl) setText(subtotalPeopleEl, ' · ' + totalQty + ' ' + peopleWord(totalQty));
    var grandTotalEl = document.querySelector('[data-v2-total]');
    if (grandTotalEl) setText(grandTotalEl, moneyFmt(totalFinal));

    var row = document.querySelector('[data-v2-summary-row]');
    if (row) {
      var peopleEl  = row.querySelector('[data-v2-summary-people]');
      var savingsEl = row.querySelector('[data-v2-summary-savings]');
      var totalEl   = row.querySelector('[data-v2-summary-total]');
      if (peopleEl) setText(peopleEl, totalQty + ' ' + peopleWord(totalQty));
      if (totalEl)  setText(totalEl, 'Total ' + moneyFmt(totalFinal));
      if (savingsEl) setHidden(savingsEl, true);
      setHidden(row, false);
    }
  }

  function applyProductPagePreview() {
    var formWrapper = document.querySelector('[data-form-wrapper]');
    if (!formWrapper) return;

    var peopleField = document.querySelector('[data-form-wrapper] [data-quantity-field]');
    var priceEls = document.querySelectorAll('[data-product-price]');
    var discountedEls = document.querySelectorAll('[data-product-discounted-price]');
    if (!priceEls.length || !discountedEls.length) return;

    var qty = peopleField ? parseInt(peopleField.value, 10) : NaN;
    var variantPriceCents = parseInt(formWrapper.dataset.variantPrice, 10);
    var variantTitle = formWrapper.dataset.variantTitle || '';

    var result = null;
    if (DISCOUNT_CONFIG.enabled
        && !isNaN(qty) && qty >= 2
        && !isNaN(variantPriceCents)) {
      var variantPrice = variantPriceCents / 100;
      var extraImages = parseExtraImages(variantTitle);
      var basePrice = variantPrice - extraImages * DISCOUNT_CONFIG.additionalImageCost;
      if (basePrice > 0) {
        var tierPct = findTierPct(qty);
        if (tierPct > 0) {
          var discountPerUnit = Math.round(basePrice * (tierPct / 100) * 100) / 100;
          if (discountPerUnit > 0) {
            result = {
              originalPrice: variantPrice,
              discountedPrice: Math.round((variantPrice - discountPerUnit) * 100) / 100
            };
          }
        }
      }
    }

    if (!result) {
      priceEls.forEach(function (el) {
        if (el.classList.contains('product__price--struck')) {
          el.classList.remove('product__price--struck');
        }
      });
      discountedEls.forEach(function (el) {
        if (el.textContent !== '') el.textContent = '';
        if (!el.hasAttribute('hidden')) setHidden(el, true);
      });
      return;
    }

    var newDiscText = moneyFmt(result.discountedPrice);
    priceEls.forEach(function (el) {
      if (!el.classList.contains('product__price--struck')) {
        el.classList.add('product__price--struck');
      }
    });
    discountedEls.forEach(function (el) {
      if (el.textContent !== newDiscText) el.textContent = newDiscText;
      if (el.hasAttribute('hidden')) setHidden(el, false);
    });
  }

  function onCartChanged() {
    requestAnimationFrame(applyGroupDiscount);
  }
  document.addEventListener('theme:cart:added', onCartChanged);
  document.addEventListener('theme:cart:change', onCartChanged);
  document.addEventListener('theme:cart:update', onCartChanged);

  function initCartFootObserver() {
    var dwCartEl = document.querySelector('[data-cart-drawer]');
    if (!dwCartEl || !window.MutationObserver) return;
    var dwTimer = null;
    new MutationObserver(function () {
      clearTimeout(dwTimer);
      dwTimer = setTimeout(applyGroupDiscount, 80);
    }).observe(dwCartEl, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-quantity-field]')) return;
    var insideCart = e.target.closest('[data-cart-item]');
    if (insideCart) {
      setTimeout(applyGroupDiscount, 50);
    } else {
      setTimeout(applyProductPagePreview, 50);
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches) return;
    if (!e.target.matches('[data-single-option-selector]')) return;

    var productInfo = e.target.closest('product-info')
                   || document.querySelector('product-info');
    if (!productInfo) return;

    var observer = new MutationObserver(function () {
      applyProductPagePreview();
    });
    observer.observe(productInfo, { childList: true, subtree: true });

    setTimeout(function () {
      observer.disconnect();
      applyProductPagePreview();
    }, 1500);
  });

  var GD_LOADER_SVG =
    '<svg class="bp-loader-spinner" xmlns="http://www.w3.org/2000/svg" ' +
    'width="20" height="20" fill="#ff4848" viewBox="0 0 256 256" ' +
    'aria-hidden="true" focusable="false">' +
    '<path d="M132,32V64a4,4,0,0,1-8,0V32a4,4,0,0,1,8,0Zm41.25,54.75a' +
    '4,4,0,0,0,2.83-1.18L198.71,63a4,4,0,0,0-5.66-5.66L170.43,79.92a' +
    '4,4,0,0,0,2.82,6.83ZM224,124H192a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8Zm' +
    '-47.92,46.43a4,4,0,1,0-5.65,5.65l22.62,22.63a4,4,0,0,0,5.66-5.66Z' +
    'M128,188a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V192A4,4,0,0,0,128,188ZM79.92,' +
    '170.43,57.29,193.05A4,4,0,0,0,63,198.71l22.62-22.63a4,4,0,1,0-5.65' +
    '-5.65ZM68,128a4,4,0,0,0-4-4H32a4,4,0,0,0,0,8H64A4,4,0,0,0,68,128Z' +
    'M63,57.29A4,4,0,0,0,57.29,63L79.92,85.57a4,4,0,1,0,5.65-5.65Z"/>' +
    '</svg>';

  var GD_LOADER_ACTION = 'discount';
  var GD_REMOVING_CARD = null;
  var GD_CHANGED_CARD = null;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var removeLink = e.target.closest('.cart__item__remove, [data-item-remove]');
    if (removeLink) {
      GD_LOADER_ACTION = 'removing';
      GD_REMOVING_CARD = removeLink.closest('.cart-item-v2');
      GD_CHANGED_CARD = null;
      return;
    }
    var qtyBtn = e.target.closest('[data-quantity-button]');
    if (qtyBtn) {
      GD_LOADER_ACTION = 'discount';
      GD_CHANGED_CARD = qtyBtn.closest('.cart-item-v2');
      GD_REMOVING_CARD = null;
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-quantity-field]')) {
      var card = e.target.closest('.cart-item-v2');
      if (card) { GD_LOADER_ACTION = 'discount'; GD_CHANGED_CARD = card; GD_REMOVING_CARD = null; }
    }
  }, true);

  function appendLoader(card, label) {
    if (!card) return;
    if (card.querySelector('.group-discount-loader')) return;
    var loader = document.createElement('div');
    loader.className = 'group-discount-loader';
    loader.innerHTML = GD_LOADER_SVG + ' ' + label;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (!isMobile) {
      var perPerson = card.querySelector('[data-v2-per-person]');
      if (perPerson) {
        perPerson.appendChild(loader);
        setHidden(perPerson, false);
        return;
      }
    }

    var row1 = card.querySelector('.cart-item-v2__row1');
    if (row1 && row1.parentNode === card) {
      row1.insertAdjacentElement('afterend', loader);
    } else {
      card.appendChild(loader);
    }
  }

  function showCartLoadingState() {
    if (GD_LOADER_ACTION === 'removing') {
      if (GD_REMOVING_CARD) {
        appendLoader(GD_REMOVING_CARD, 'Removing…');
      }
      return;
    }
    if (GD_CHANGED_CARD) {
      appendLoader(GD_CHANGED_CARD, 'Applying group discount…');
      return;
    }
    document.querySelectorAll('.cart-item-v2').forEach(function (card) {
      appendLoader(card, 'Applying group discount…');
    });
  }

  function hideCartLoadingState() {
    document.querySelectorAll('.group-discount-loader').forEach(function (el) {
      el.remove();
    });
    GD_LOADER_ACTION = 'discount';
    GD_REMOVING_CARD = null;
    GD_CHANGED_CARD = null;
  }

  function initCartLoadingObserver() {
    var drawer = document.querySelector('cart-element[data-cart-drawer]');
    if (!drawer) return;
    new MutationObserver(function () {
      if (drawer.classList.contains('is-loading')) {
        showCartLoadingState();
      } else {
        hideCartLoadingState();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  window.__bpGroupDiscount = {
    refreshProductPage: applyProductPagePreview,
    refreshCart: applyGroupDiscount
  };

  function onReady() {
    applyGroupDiscount();
    applyProductPagePreview();
    initCartLoadingObserver();
    initCartFootObserver();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

(function () {
  'use strict';

  var DEBOUNCE_MS = 550;
  var timers          = new WeakMap();
  var inFlightKeys    = new Set();
  var pendingByKey    = new Map();

  function dispatchUpdate(item, key, qty) {
    inFlightKeys.add(key);
    item.dispatchEvent(new CustomEvent('theme:cart:update', {
      bubbles: true,
      detail: { id: key, quantity: qty },
    }));
  }

  function onCartSettled() {
    inFlightKeys.clear();
    if (pendingByKey.size === 0) return;
    var entries = Array.from(pendingByKey.entries());
    pendingByKey.clear();
    entries.forEach(function (entry) {
      var key = entry[0], qty = entry[1];
      var newInput = document.querySelector('[data-quantity-field][data-id="' + key + '"]');
      if (!newInput) return;
      var newItem = newInput.closest('.cart-item-v2');
      if (!newItem) return;
      newInput.value = qty;
      dispatchUpdate(newItem, key, qty);
    });
  }
  document.addEventListener('theme:cart:added', onCartSettled);

  function armDebounce(item, input) {
    if (timers.has(item)) clearTimeout(timers.get(item));
    var t = setTimeout(function () {
      timers.delete(item);
      var key = input.getAttribute('data-id');
      var finalQty = parseInt(input.value, 10);
      if (isNaN(finalQty) || finalQty < 1) finalQty = 1;

      var maxAttr = parseInt(input.getAttribute('data-quantity-max'), 10);
      if (!isNaN(maxAttr) && maxAttr > 0 && finalQty > maxAttr) {
        finalQty = maxAttr;
        input.value = finalQty;
      }

      if (inFlightKeys.has(key)) {
        pendingByKey.set(key, finalQty);
        return;
      }
      dispatchUpdate(item, key, finalQty);
    }, DEBOUNCE_MS);
    timers.set(item, t);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-button]');
    if (!btn) return;
    var item = btn.closest('.cart-item-v2');
    if (!item) return;
    var input = item.querySelector('[data-quantity-field]');
    if (!input) return;

    e.stopPropagation();
    e.preventDefault();

    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 1;

    var max = parseInt(input.getAttribute('data-quantity-max'), 10);
    if (isNaN(max) || max <= 0) max = Infinity;

    var isPlus  = btn.matches('[data-quantity-plus]')  || !!btn.closest('[data-quantity-plus]');
    var isMinus = btn.matches('[data-quantity-minus]') || !!btn.closest('[data-quantity-minus]');
    var next    = current;
    if (isPlus)  next = Math.min(current + 1, max);
    if (isMinus) next = Math.max(current - 1, 1);

    if (next === current) return;

    input.value = next;
    armDebounce(item, input);
  }, true);

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || !input.matches) return;
    if (!input.matches('[data-quantity-field]')) return;
    var item = input.closest('.cart-item-v2');
    if (!item) return;

    e.stopPropagation();
    armDebounce(item, input);
  }, true);
})();

(function () {
  'use strict';

  var lastEscapeAt = 0;

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.code === 'Escape') {
      lastEscapeAt = Date.now();
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (Date.now() - lastEscapeAt > 200) return;
    var toggle = e.target.closest && e.target.closest('[data-cart-drawer-toggle]');
    if (!toggle) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    if (window.console && window.console.debug) {
      window.console.debug('[bp-guard] suppressed Escape-triggered cart toggle click');
    }
  }, true);
})();

(function () {
  var LIGHTBOX_IMG_SELECTOR =
    'img.page-gallery-dialog__img, img.backdrops-dialog__img, img.photo-grid__dialog-img, img.bp-lightbox-img, img.bp-gallery-zoom__img';

  var SPINNER_DELAY_MS = 50;

  function wrapBpLightboxControls(dialog) {
    if (!dialog.classList || !dialog.classList.contains('bp-lightbox-dialog')) return;
    if (dialog.querySelector('.bp-lightbox-controls')) return;
    var inner = dialog.querySelector('.bp-lightbox-inner');
    var prev = dialog.querySelector('.bp-lightbox-prev');
    var next = dialog.querySelector('.bp-lightbox-next');
    if (!inner || !prev || !next) return;
    var controls = document.createElement('div');
    controls.className = 'bp-lightbox-controls';
    controls.appendChild(prev);
    controls.appendChild(next);
    inner.appendChild(controls);
  }

  function wrapPageGalleryControls(dialog) {
    if (!dialog.classList || !dialog.classList.contains('page-gallery-dialog')) return;
    if (dialog.querySelector('.page-gallery-dialog__controls')) return;
    var inner = dialog.querySelector('.page-gallery-dialog__inner');
    var prev = dialog.querySelector('.page-gallery-dialog__prev');
    var next = dialog.querySelector('.page-gallery-dialog__next');
    if (!inner || !prev || !next) return;
    var controls = document.createElement('div');
    controls.className = 'page-gallery-dialog__controls';
    controls.appendChild(prev);
    controls.appendChild(next);
    inner.appendChild(controls);
  }
  function wireDialog(dialog) {
    wrapBpLightboxControls(dialog);
    wrapPageGalleryControls(dialog);
    var img = dialog.querySelector(LIGHTBOX_IMG_SELECTOR);
    if (!img || img.__bpLoadingWired) return;
    img.__bpLoadingWired = true;

    var spinnerTimer = null;

    function clearSpinnerTimer() {
      if (spinnerTimer !== null) { clearTimeout(spinnerTimer); spinnerTimer = null; }
    }

    function setLoading(loading) {
      if (loading) {
        img.style.opacity = '0';
        clearSpinnerTimer();
        spinnerTimer = setTimeout(function () {
          spinnerTimer = null;
          dialog.dataset.loading = 'true';
        }, SPINNER_DELAY_MS);
      } else {
        clearSpinnerTimer();
        dialog.dataset.loading = 'false';
        img.style.opacity = '1';
      }
    }

    img.addEventListener('load', function () { setLoading(false); });
    img.addEventListener('error', function () { setLoading(false); });

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName !== 'src') return;
        var src = img.getAttribute('src');
        if (!src) { setLoading(false); return; }
        setLoading(true);
      });
    }).observe(img, { attributes: true, attributeFilter: ['src'] });
  }

  function init() {
    var dialogs = document.querySelectorAll('dialog');
    for (var i = 0; i < dialogs.length; i++) {
      var d = dialogs[i];
      if (d.querySelector(LIGHTBOX_IMG_SELECTOR)) {
        wireDialog(d);
      }
    }
  }

  function startBodyWatcher() {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (!node || node.nodeType !== 1) continue;
          if (node.tagName === 'DIALOG' && node.querySelector(LIGHTBOX_IMG_SELECTOR)) {
            wireDialog(node);
          }
        }
      });
    }).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); startBodyWatcher(); });
  } else {
    init();
    if (document.body) startBodyWatcher();
  }
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  function initPageGalleries() {
    var grids = document.querySelectorAll('.page-gallery');
    if (!grids.length) return;

    var galleries = [];
    for (var i = 0; i < grids.length; i++) {
      var grid = grids[i];
      if (!grid.id) continue;
      var dlg = document.getElementById(grid.id + '-dialog');
      if (!dlg) continue;
      galleries.push({
        grid: grid,
        dialog: dlg,
        imgEl: dlg.querySelector('.page-gallery-dialog__img')
      });
    }
    if (!galleries.length) return;

    var items = [];
    galleries.forEach(function (g) {
      var btns = g.grid.querySelectorAll('[data-i]');
      btns.forEach(function (btn) {
        var img = btn.querySelector('img');
        if (!img) return;
        items.push({
          s: img.getAttribute('data-f') || img.src,
          a: img.alt,
          btn: btn,
          gallery: g
        });
      });
    });
    if (!items.length) return;

    var cur = 0;
    var activeGallery = null;

    function show(n) {
      cur = (n + items.length) % items.length;
      if (activeGallery && activeGallery.imgEl) {
        activeGallery.imgEl.style.opacity = '0';
        activeGallery.imgEl.src = items[cur].s;
        activeGallery.imgEl.alt = items[cur].a;
      }
    }

    function open(combinedIdx) {
      cur = combinedIdx;
      activeGallery = items[cur].gallery;
      if (activeGallery.imgEl) {
        activeGallery.imgEl.style.opacity = '0';
        activeGallery.imgEl.src = items[cur].s;
        activeGallery.imgEl.alt = items[cur].a;
      }
      activeGallery.dialog.showModal();
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (activeGallery) activeGallery.dialog.close();
      activeGallery = null;
      document.body.style.overflow = '';
    }

    items.forEach(function (item, idx) {
      item.btn.addEventListener('click', function (e) {
        e.preventDefault();
        open(idx);
      });
    });

    galleries.forEach(function (g) {
      var closeBtn = g.dialog.querySelector('.page-gallery-dialog__close');
      var prevBtn  = g.dialog.querySelector('.page-gallery-dialog__prev');
      var nextBtn  = g.dialog.querySelector('.page-gallery-dialog__next');
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevBtn)  prevBtn.addEventListener('click', function () { show(cur - 1); });
      if (nextBtn)  nextBtn.addEventListener('click', function () { show(cur + 1); });
      if (prevBtn && nextBtn && !g.dialog.querySelector('.page-gallery-dialog__controls')) {
        var inner = g.dialog.querySelector('.page-gallery-dialog__inner');
        if (inner) {
          var controls = document.createElement('div');
          controls.className = 'page-gallery-dialog__controls';
          controls.appendChild(prevBtn);
          controls.appendChild(nextBtn);
          inner.appendChild(controls);
        }
      }
      g.dialog.addEventListener('click', function (e) {
        if (e.target === g.dialog) close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!activeGallery || !activeGallery.dialog.open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageGalleries);
  } else {
    initPageGalleries();
  }
})();

(function () {
  if (!/^\/policies\//.test(window.location.pathname)) return;

  function deriveIdFromHeader(headerEl) {
    if (!headerEl.id) return null;
    if (headerEl.id.slice(-2) !== '-h') return null;
    return headerEl.id.slice(0, -2);
  }

  var path = window.location.pathname;
  var slugs = {
    privacy:  '/policies/privacy-policy',
    terms:    '/policies/terms-of-service',
    refund:   '/policies/refund-policy',
    shipping: '/policies/shipping-policy',
    contact:  '/policies/contact-information'
  };
  var active = '';
  Object.keys(slugs).forEach(function (k) {
    if (path.indexOf(slugs[k]) !== -1) active = k;
  });
  var asideLabel = {
    privacy:  'Contact the Privacy Officer',
    terms:    'Contact the Terms Officer',
    refund:   'Contact the team',
    shipping: 'Contact the team',
    contact:  'Contact the team'
  }[active] || 'Contact the team';

  function rebuildArticleStructure(root) {
    if (!root || root.__bpPolicyRebuilt) return;
    root.__bpPolicyRebuilt = true;

    var docShell = root.querySelector('.bp-doc-shell');
    if (docShell) {
      var tocH = docShell.querySelector(':scope > .bp-toc-h, :scope > p.bp-toc-h');
      if (tocH && !docShell.querySelector(':scope > .bp-toc')) {
        var tocOl = tocH.nextElementSibling;
        if (tocOl && tocOl.tagName === 'OL') {
          var tocNav = document.createElement('nav');
          tocNav.className = 'bp-toc';
          tocNav.setAttribute('aria-label', 'Table of contents');
          docShell.insertBefore(tocNav, tocH);
          tocNav.appendChild(tocH);
          tocNav.appendChild(tocOl);
        }
      }
    }

    var doc = root.querySelector('.bp-doc');
    if (doc && !doc.querySelector(':scope > section.bp-part') && !doc.querySelector(':scope > section.bp-sect')) {
      var docChildren = Array.from(doc.children);
      var hasParts = docChildren.some(function (c) { return c.matches && c.matches('.bp-part-h'); });
      var hasSects = docChildren.some(function (c) { return c.matches && c.matches('.bp-sect-h'); });

      if (hasParts || hasSects) {
        var newDocChildren = [];
        var i = 0;

        while (i < docChildren.length) {
          var child = docChildren[i];

          if (child.matches('.bp-part-h')) {
            var partSection = document.createElement('section');
            partSection.className = 'bp-part';
            var partId = deriveIdFromHeader(child);
            if (partId) partSection.id = partId;
            partSection.appendChild(child);
            i++;

            while (i < docChildren.length && !docChildren[i].matches('.bp-part-h')) {
              var inPart = docChildren[i];
              if (inPart.matches('.bp-sect-h')) {
                var sectInPart = document.createElement('section');
                sectInPart.className = 'bp-sect';
                var sectInPartId = deriveIdFromHeader(inPart);
                if (sectInPartId) sectInPart.id = sectInPartId;
                sectInPart.appendChild(inPart);
                i++;
                while (i < docChildren.length &&
                       !docChildren[i].matches('.bp-part-h') &&
                       !docChildren[i].matches('.bp-sect-h')) {
                  sectInPart.appendChild(docChildren[i]);
                  i++;
                }
                partSection.appendChild(sectInPart);
              } else {
                partSection.appendChild(inPart);
                i++;
              }
            }
            newDocChildren.push(partSection);
          } else if (child.matches('.bp-sect-h')) {
            var sectAlone = document.createElement('section');
            sectAlone.className = 'bp-sect';
            var sectAloneId = deriveIdFromHeader(child);
            if (sectAloneId) sectAlone.id = sectAloneId;
            sectAlone.appendChild(child);
            i++;
            while (i < docChildren.length &&
                   !docChildren[i].matches('.bp-part-h') &&
                   !docChildren[i].matches('.bp-sect-h')) {
              sectAlone.appendChild(docChildren[i]);
              i++;
            }
            newDocChildren.push(sectAlone);
          } else {
            newDocChildren.push(child);
            i++;
          }
        }

        while (doc.firstChild) doc.removeChild(doc.firstChild);
        newDocChildren.forEach(function (n) { doc.appendChild(n); });
      }
    }

    var tldr = root.querySelector('.bp-tldr');
    if (tldr && !tldr.querySelector(':scope > .bp-tldr-head')) {
      var tldrFirst = tldr.firstElementChild;
      if (tldrFirst && tldrFirst.classList.contains('bp-eyebrow')) {
        var tldrHeadDiv = document.createElement('div');
        tldrHeadDiv.className = 'bp-tldr-head';
        var maybeH2 = tldrFirst.nextElementSibling;
        tldr.insertBefore(tldrHeadDiv, tldrFirst);
        tldrHeadDiv.appendChild(tldrFirst);
        if (maybeH2 && (maybeH2.classList.contains('bp-h2') || maybeH2.tagName === 'H2')) {
          tldrHeadDiv.appendChild(maybeH2);
        }
      }
    }

    var contactH = root.querySelector('#bp-contact-h');
    if (contactH && !root.querySelector(':scope > .bp-contact')) {
      var node = contactH;
      while (node && node.parentElement && node.parentElement !== root) {
        node = node.parentElement;
      }
      if (node && node.parentElement === root) {
        var contactDiv = node;
        var contactDl = contactDiv.nextElementSibling;
        var contactSection = document.createElement('section');
        contactSection.className = 'bp-contact';
        contactSection.id = 'bp-contact';
        root.insertBefore(contactSection, contactDiv);
        contactSection.appendChild(contactDiv);
        if (contactDl && contactDl.tagName === 'DL') {
          contactSection.appendChild(contactDl);
        }
      }
    }

    var heroEnd = root.querySelector(':scope > .bp-tldr, :scope > .bp-doc-shell');
    if (heroEnd && !root.querySelector(':scope > .bp-head')) {
      var headDiv = document.createElement('div');
      headDiv.className = 'bp-head';
      var movers = [];
      var n = root.firstElementChild;
      while (n && n !== heroEnd) {
        movers.push(n);
        n = n.nextElementSibling;
      }
      root.insertBefore(headDiv, heroEnd);
      movers.forEach(function (m) { headDiv.appendChild(m); });
    }

    var plainH4s = root.querySelectorAll('h4:not(.bp-sub-h)');
    plainH4s.forEach(function (h4) {
      if (h4.closest('.bp-callout')) return;
      if (!h4.parentNode) return;
      var aside = document.createElement('aside');
      aside.className = 'bp-callout';
      h4.parentNode.insertBefore(aside, h4);
      aside.appendChild(h4);
      if (aside.nextElementSibling && aside.nextElementSibling.tagName === 'P') {
        aside.appendChild(aside.nextElementSibling);
      }
    });
  }

  function injectChrome(sopContainer) {
    if (!sopContainer || sopContainer.__bpPolicyWrapped) return;
    sopContainer.__bpPolicyWrapped = true;

    var rte = sopContainer.querySelector('.shopify-policy__body .rte');
    if (rte) {
      rte.classList.add('bp-policy');
      rebuildArticleStructure(rte);
    }

    function tab(slug, num, label, key) {
      var cls = (key === active) ? ' class="is-active" aria-current="page"' : '';
      return '<li><a href="' + slug + '"' + cls + '><span class="num">' + num + '</span> ' + label + '</a></li>';
    }
    function relcard(slug, num, hHtml, dText, key) {
      if (key === active) {
        return '<div class="bp-policy-relcard bp-policy-relcard--current">' +
          '<span class="bp-policy-relcard__pill">Reading now</span>' +
          '<div class="bp-policy-relcard__num">' + num + ' of 05</div>' +
          '<h3 class="bp-policy-relcard__h">' + hHtml + '</h3>' +
          '<p class="bp-policy-relcard__d">' + dText + '</p>' +
        '</div>';
      }
      return '<a class="bp-policy-relcard" href="' + slug + '">' +
        '<div class="bp-policy-relcard__num">' + num + ' of 05</div>' +
        '<h3 class="bp-policy-relcard__h">' + hHtml + '</h3>' +
        '<p class="bp-policy-relcard__d">' + dText + '</p>' +
        '<span class="bp-policy-relcard__cta">Read policy <span class="arr">&rarr;</span></span>' +
      '</a>';
    }

    var ptabsHTML =
      '<nav class="bp-policy-ptabs" aria-label="Policy switcher">' +
        '<span class="bp-policy-ptabs__label">Policies</span>' +
        '<ul class="bp-policy-ptabs__list">' +
          tab(slugs.privacy,  '01', 'Privacy',                       'privacy') +
          tab(slugs.terms,    '02', 'Terms',                         'terms') +
          tab(slugs.refund,   '03', 'Booking &amp; Cancellation',    'refund') +
          tab(slugs.shipping, '04', 'Shipping',                      'shipping') +
          tab(slugs.contact,  '05', 'Contact Info',                  'contact') +
        '</ul>' +
        '<div class="bp-policy-ptabs__aside">Questions? <a href="#bp-contact">' + asideLabel + '</a></div>' +
      '</nav>';

    var relatedHTML =
      '<section class="bp-policy-related" aria-label="Other policies">' +
        '<div class="bp-policy-related__head">' +
          '<h2 class="bp-policy-related__h">The other four <em>policies.</em></h2>' +
        '</div>' +
        '<div class="bp-policy-related__grid">' +
          relcard(slugs.privacy,  '01', 'Privacy <em>Policy</em>',             'How BusinessPortraits.ca handles personal information across the website, booking, proof gallery, and downstream marketing.', 'privacy') +
          relcard(slugs.terms,    '02', 'Terms of <em>Service</em>',           'The full operating agreement: booking, payment, licensing, subscription plans, liability, and dispute resolution.',           'terms') +
          relcard(slugs.refund,   '03', 'Booking &amp; <em>Cancellation</em>', 'All sales final. Reschedule with 48+ hours notice is free; inside 48 hours, the 65/35 credit-split applies.',                 'refund') +
          relcard(slugs.shipping, '04', 'Shipping <em>Policy</em>',            'Print products, framed items, and physical goods. Processing time, international shipping, customs, and risk of loss.',     'shipping') +
          relcard(slugs.contact,  '05', 'Contact <em>Information</em>',        'How to reach the team: general inquiries, rescheduling, Terms Officer, and a one-business-day response.',                   'contact') +
        '</div>' +
      '</section>';

    var finalCtaFirstSentence = ({
      privacy:  'Privacy is built into the booking flow, not bolted on after.',
      terms:    'The agreement runs from booking to delivery; read it once and it covers everything.',
      refund:   'Forty-eight hours is the line; outside it, rescheduling is free and routine.',
      shipping: 'Tracked courier from press to door, with international shipping on offer.',
      contact:  'Email, phone, or contact form, all paths land in the same inbox.'
    })[active] || 'The policies set the terms; the booking sets the date.';

    var finalCtaHTML =
      '<section class="bp-policy-final-cta">' +
        '<h2>Read the policies. Then <em>book the day.</em></h2>' +
        '<p>' + finalCtaFirstSentence + ' The team responds to every inquiry within one business day across the GTA.</p>' +
        '<div class="bp-policy-final-cta__actions">' +
          '<a class="btn btn--solid btn--white btn--medium" href="/products/professional-business-portrait">Book a Team Headshot Day</a> ' +
          '<a class="btn btn--outline btn--white btn--medium" href="/pages/contact-us">Contact the team</a>' +
        '</div>' +
      '</section>';

    var canvas = document.createElement('div');
    canvas.className = 'bp-policy-canvas';
    var frame = document.createElement('div');
    frame.className = 'bp-policy-frame';
    canvas.appendChild(frame);

    sopContainer.parentNode.insertBefore(canvas, sopContainer);
    frame.insertAdjacentHTML('beforeend', ptabsHTML);
    frame.appendChild(sopContainer);
    frame.insertAdjacentHTML('beforeend', relatedHTML);
    frame.insertAdjacentHTML('beforeend', finalCtaHTML);
  }

  function run() {
    var customArticle = document.querySelector('.bp-policy-frame .bp-policy, .bp-policy-frame article.bp-policy');
    if (customArticle) {
      rebuildArticleStructure(customArticle);
      return;
    }
    var sopContainer = document.querySelector('.shopify-policy__container');
    if (sopContainer) injectChrome(sopContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

(function () {
  function isPhoto(target) {
    return !!(target && target.closest && target.closest('img, picture, video, .pswp__img, .pswp__zoom-wrap'));
  }
  document.addEventListener('contextmenu', function (e) {
    if (isPhoto(e.target)) e.preventDefault();
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (isPhoto(e.target)) e.preventDefault();
  }, true);
})();
